import moment from 'moment';
// import { useSnackbar } from 'notistack';
import {
  // Button,
  // TextField,
  // Grid,
  Typography,
} from '@material-ui/core';
// import { Add, Cancel, Save } from '@material-ui/icons';
// import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
// import parse from 'html-react-parser';
// import Editor from '../Editor';
import {
  // updateContent,
  // postContent,
  getFormApp,
} from '../../../services';

// const useStyles = makeStyles((theme: Theme) =>
// 	createStyles({
// 		root: {
// 			display: 'flex',
// 			flexDirection: 'column',
// 			alignItems: 'flex-start',

// 			'& > *': {
// 				margin: theme.spacing(1),
// 				maxWidth: '1000px',
// 			},
// 		},
// 		rootRadio: {
// 			marginTop: '.5rem',
// 		},
// 	})
// );

// const FormCrudDataPengumuman = ({
// 	onCancel,
// 	action,
// 	type,
// 	title,
// 	data,
// }: // hasContract,
// any) => {
// 	const isAdd = action === 'Add' ? true : false;
// 	const initForm = {
// 		title_id: '',
// 		title_en: '',
// 		sub_title_id: '',
// 		sub_title_en: '',
// 		content_id: '',
// 		content_en: '',
// 		place: '',
// 		contract: '',
// 	};
// 	const classes = useStyles();
// 	const { enqueueSnackbar } = useSnackbar();
// 	const [formState, setFormState] = useState(isAdd ? initForm : data);
// 	const {
// 		title_id,
// 		title_en,
// 		sub_title_id,
// 		sub_title_en,
// 		content_id,
// 		content_en,
// 		place,
// 		contract,
// 	} = formState;

// 	const handleChange = (event: any) => {
// 		setFormState({ ...formState, [event.target.name]: event.target.value });
// 	};

// 	const handleAddCrudDataPengumuman = async (e: any) => {
// 		e.preventDefault();
// 		const body = new FormData();
// 		body.append('title_id', title_id);
// 		body.append('title_en', title_en);
// 		body.append('sub_title_id', sub_title_id);
// 		body.append('sub_title_en', sub_title_en);
// 		body.append('place', place);
// 		body.append('contract', contract);
// 		body.append('content_id', content_id);
// 		body.append('content_en', content_en);
// 		body.append('type', type);

// 		try {
// 			const res = await postContent(body);
// 			if (res.status === 'error') {
// 				enqueueSnackbar(res.message, {
// 					variant: 'error',
// 				});
// 				return;
// 			}
// 			enqueueSnackbar(`Berhasil menambahkan data ${title}`, {
// 				variant: 'success',
// 			});
// 			onCancel();
// 		} catch (err) {
// 			enqueueSnackbar(err.message, {
// 				variant: 'error',
// 			});
// 		}
// 	};

// 	const handleEditCrudDataPengumuman = async (e: any) => {
// 		e.preventDefault();
// 		const body = new FormData();
// 		body.append('title_id', title_id);
// 		body.append('title_en', title_en);
// 		body.append('sub_title_id', sub_title_id);
// 		body.append('sub_title_en', sub_title_en);
// 		body.append('content_id', content_id);
// 		body.append('content_en', content_en);
// 		body.append('place', place);
// 		body.append('contract', contract);

// 		try {
// 			const res = await updateContent(data?.id, body);
// 			if (res.status === 'error') {
// 				enqueueSnackbar(res.message, {
// 					variant: 'error',
// 				});
// 				return;
// 			}
// 			enqueueSnackbar(`Berhasil merubah data ${title_id}`, {
// 				variant: 'success',
// 			});
// 			onCancel();
// 		} catch (err) {
// 			enqueueSnackbar(err.message, {
// 				variant: 'error',
// 			});
// 		}
// 	};

// 	return (
// 		<form
// 			onSubmit={
// 				isAdd ? handleAddCrudDataPengumuman : handleEditCrudDataPengumuman
// 			}
// 			className={classes.root}
// 			noValidate
// 			autoComplete="off"
// 		>
// 			<Typography color="primary" variant="h4" style={{ marginBottom: '2rem' }}>
// 				{isAdd ? 'Add' : 'Edit'} Data {title}
// 			</Typography>

// 			<Grid container spacing={3}>
// 				<Grid item xs={6}>
// 					<TextField
// 						onChange={handleChange}
// 						value={title_id}
// 						name="title_id"
// 						label="Title ID"
// 						variant="outlined"
// 						fullWidth
// 						required
// 					/>
// 				</Grid>
// 				<Grid item xs={6}>
// 					<TextField
// 						onChange={handleChange}
// 						value={title_en}
// 						name="title_en"
// 						label="Title EN"
// 						variant="outlined"
// 						fullWidth
// 						required
// 					/>
// 				</Grid>
// 				<Grid item xs={6}>
// 					<TextField
// 						onChange={handleChange}
// 						value={sub_title_id}
// 						name="sub_title_id"
// 						label="Sub Title ID"
// 						variant="outlined"
// 						fullWidth
// 						required
// 					/>
// 				</Grid>
// 				<Grid item xs={6}>
// 					<TextField
// 						onChange={handleChange}
// 						value={sub_title_en}
// 						name="sub_title_en"
// 						label="Sub Title EN"
// 						variant="outlined"
// 						fullWidth
// 						required
// 					/>
// 				</Grid>
// 				<Grid item xs={6} md={6}>
// 					<Editor
// 						content={content_id}
// 						onChange={(content: any) =>
// 							setFormState({ ...formState, content_id: content })
// 						}
// 					/>
// 				</Grid>
// 				<Grid item xs={6} md={6}>
// 					<Editor
// 						content={content_en}
// 						onChange={(content: any) =>
// 							setFormState({ ...formState, content_en: content })
// 						}
// 					/>
// 				</Grid>
// 				<Grid item xs={12}>
// 					<TextField
// 						onChange={handleChange}
// 						value={place}
// 						name="place"
// 						label="Place"
// 						variant="outlined"
// 						fullWidth
// 						required
// 					/>
// 				</Grid>
// 				{/* {hasContract && (
// 					<Grid item xs={12}>
// 						<TextField
// 							onChange={handleChange}
// 							value={contract}
// 							name="contract"
// 							label="Contract"
// 							variant="outlined"
// 							fullWidth
// 							required
// 						/>
// 					</Grid>
// 				)} */}

// 				<Grid item xs={12}>
// 					<Button
// 						variant="outlined"
// 						color="primary"
// 						size="large"
// 						startIcon={<Cancel />}
// 						style={{ marginRight: '1rem' }}
// 						onClick={onCancel}
// 					>
// 						Cancel
// 					</Button>
// 					<Button
// 						variant="contained"
// 						color="primary"
// 						size="large"
// 						startIcon={<Save />}
// 						type="submit"
// 					>
// 						Save
// 					</Button>
// 				</Grid>
// 			</Grid>
// 		</form>
// 	);
// };

const CrudDataPengumuman = ({ title, type }: any) => {
  // const initAddState = { open: false, action: 'Add' };
  // const [actionState, setActionState] = useState(initAddState);
  // const [editState, setEditState] = useState<any>(null);
  const columnLowongan: any = [
    { title: 'ID Lowongan', field: 'id_content' },
    { title: 'Nama Lengkap', field: 'fullname' },
    { title: 'Email', field: 'email' },
    { title: 'No.Handphone', field: 'hp' },
    {
      title: 'CV',
      field: 'cv',
      render: (rowData: any) => (
        <a
          target='_blank'
          rel='noreferrer'
          href={`${process.env.REACT_APP_URL}/cv/${rowData.cv}`}
        >
          {rowData.cv}
        </a>
      ),
    },

    {
      title: 'Created',
      field: 'created_at',
      align: 'right',
      render: (rowData: any) =>
        moment(rowData.created_at).format('YYYY-MM-DD HH:mm'),
    },
  ];

  const columnPengadaan: any = [
    { title: 'ID Pengadaan', field: 'id_content' },
    { title: 'Nama Perusahaan', field: 'company_name' },
    { title: 'Alamat Perusahaan', field: 'company_address' },
    { title: 'Telepon', field: 'tlp' },
    { title: 'Kontak Person', field: 'contact_person' },
    {
      title: 'Created',
      field: 'created_at',
      align: 'right',
      render: (rowData: any) =>
        moment(rowData.created_at).format('YYYY-MM-DD HH:mm'),
    },
  ];

  // if (hasContract)
  //   columnTable.splice(5, 0, { title: 'Contract', field: 'contract' });

  return (
    // <>
    // 	{actionState.open ? (
    // 		<h1>testing</h1>
    // 	) : (
    // 		<FormCrudDataPengumuman
    // 			title={title}
    // 			type={type}
    // 			action={actionState.action}
    // 			onCancel={() => setActionState(initAddState)}
    // 			data={editState}
    // 			// hasContract={hasContract}
    // 		/>
    // <>
    // 	<div
    // 		style={{
    // 			display: 'flex',
    // 			justifyContent: 'flex-end',
    // 			marginBottom: '1rem',
    // 		}}
    // // 	>
    // 		<Button
    // 			variant="contained"
    // 			color="primary"
    // 			size="large"
    // 			onClick={() => {
    // 				setEditState(null);
    // 				setActionState({ open: true, action: 'Add' });
    // 			}}
    // 			startIcon={<Add />}
    // 		>
    // 			Add
    // 		</Button>
    // 	</div>
    <MaterialTable
      columns={type === 1 ? columnLowongan : columnPengadaan}
      title={
        <Typography variant='h6' color='primary' style={{ fontWeight: 600 }}>
          List {title}
        </Typography>
      }
      data={(query) =>
        new Promise((resolve) => {
          const { pageSize, page, search } = query;
          getFormApp(type, pageSize, page + 1, search)
            .then((result) => {
              resolve({
                data: result.data.rows,
                page: Number(result.data.page - 1),
                totalCount: Number(result.data.total),
              });
            })
            .catch((err) => {
              resolve({
                data: [],
                page: 1,
                totalCount: 0,
              });
            });
        })
      }
      // onRowClick={(event, rowData) => {
      // 	setEditState(rowData);
      // 	setActionState({ open: true, action: 'Edit' });
      // }}
    />
    // </>
    // 	)}
    // </>
  );
};

export default CrudDataPengumuman;
